<template>
  <div class="gVoice-Player" @click.stop="audioPlay()">
    <!-- :class="{ '-shrink': imgSize > size }" -->
    <!-- ボイス -->
    <audio
      preload="metadata"
      ref="voiceplayer"
      v-on:ended="onEnded()"
      v-on:loadedmetadata="onLoaded()"
    >
      <source
        :src="
          itemPath
            ? `${objectPath}/${itemPath}`
            : `${objectPath}/voices/main/${soundData.shouhinId}.mp3`
        "
        type="audio/mp3"
      />
    </audio>
    <div class="gVoice-Player_Icon">
      <v-icon color="white" x-small v-if="!isPlay">play_arrow</v-icon>
      <v-icon color="white" x-small class="pa-0" v-else>pause</v-icon>
      <span class="fc-white fs-xs" v-if="duration">
        {{ duration | fancyTimeFormat }}
      </span>
    </div>

    <v-avatar tile :size="$vuetify.breakpoint.xsOnly ? 80 : 100" :color="ColorGray2" class="rounded">
      <v-icon style="position: absolute;" :size="$vuetify.breakpoint.xsOnly ? 64 : 80" color="#fff">person</v-icon>
      <v-img :src="iconPath" aspect-ratio="1">
        <div
          v-if="soundData.characterIcon || soundData.galleryIcon"
          class="fill-height gVoice-Player_Gradient"
        ></div>
      </v-img>
    </v-avatar>
  </div>
</template>

<script>
export default {
  name: "SoundPlay2",
  props: {
    soundData: {
      mode: Object,
    },
    itemPath: {
      mode: String,
    },
  },
  data() {
    return {
      isPlay: false,
      duration: "",
      imgSize: 0,
    };
  },

  filters: {
    fancyTimeFormat: function (s) {
      var hr = Math.floor(s / 3600);
      var min = Math.floor((s - hr * 3600) / 60);
      var sec = Math.floor(s - hr * 3600 - min * 60);
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }
      var duration = min + ":" + sec;
      if (hr) {
        duration = hr + ":" + duration;
      }
      return duration;
    },
  },

  computed: {
    iconPath() {
      if (this.soundData.galleryIcon) {
        return `${this.objectPath}/images/main/${this.extractShouhinId(this.soundData.galleryIcon)}/${this.extractShouhinId(
          this.soundData.galleryIcon
        )}.webP`;
      } else if (this.soundData.characterIcon) {
        return `${this.objectPath}/images/main/${this.extractShouhinId(this.soundData.characterIcon)}/${this.extractShouhinId(
          this.soundData.characterIcon
        )}.webP`;
      }
      return "";
    },
  },

  watch: {
    // ここからサイズチェック
    // iconPath: {
    //   immediate: true,
    //   handler(src) {
    //     if (src) {
    //       this.getImageSize(src);
    //     } else {
    //       this.imgSize = 0;
    //     }
    //   },
    // },
  },

  methods: {
    //メタデータ取得
    onLoaded() {
      if (this.$refs.voiceplayer.duration != Infinity) {
        this.duration = Math.round(this.$refs.voiceplayer.duration);
      }
    },
    //再生終了時
    onEnded(i) {
      this.isPlay = false;
    },
    //再生
    audioPlay(i) {
      if (this.isPlay) {
        this.$refs.voiceplayer.pause();
        this.isPlay = false;
      } else {
        this.$refs.voiceplayer.play();
        this.isPlay = true;
      }
    },

    getImageSize(obj) {
      var img = new Image();
      img.onload = () => {
        this.imgSize = img.width;
      };
      img.src = obj;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/import.scss";

.gVoice {
  &-Player {
    position: relative;
    z-index: $z-nav;
    width: 100px;

    &_Icon {
      position: absolute;
      bottom: 2px;
      left: 2px;
      z-index: $z-nav;
      line-height: 1;
    }

    &_Gradient {
      width: 100%;
      background-image: linear-gradient(
          0deg,
          rgba(62, 53, 50, 0.8) 0%,
          rgba(62, 53, 50, 0) 24%,
          rgba(62, 53, 50, 0) 100%
      );
    }

    // &:not(.-shrink) {
    //   @media only screen and (-webkit-min-device-pixel-ratio: 1.5) {
    //     image-rendering: pixelated;
    //   }
    // }
  }

  &-Card {
    position: relative;
    z-index: $z-content;
    flex-grow: 1;
    width: (100%/12);
    min-width: 160px;
    padding: 0 16px;
    margin: 24px 0 16px;
    cursor: pointer;

    @include media($sm) {
      margin-top: 16px;
      margin-bottom: 24px;
    }

    &:hover::before {
      position: absolute;
      top: -16px;
      right: 8px;
      bottom: -8px;
      left: 8px;
      z-index: -1;
      display: block;
      content: "";
      background-color: var(--gray-1);
      border-radius: 4px;
      @include media($sm) {
        right: 0;
        left: 0;
      }
    }

    &_LinkBox {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: $z-content;
      display: block;
    }

    &_Icon {
      flex-shrink: 0;
      width: 100px;
      height: 100px;
      margin-right: 8px;
    }

    &_Name {
      @include ellipsis;

      font-size: $fs-xs;
      font-weight: bold;
      line-height: 1;
      color: var(--gray-6);
    }

    &_Item {
      @include clamp(2);
      min-height: 30px;
    }

    &_Footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: $fs-xs;
      color: var(--gray-6);
    }

    &_Deadline {
      flex-grow: 2;
      text-align: right;
    }
  }

  &-Card-spacer {
    height: 0;
    margin: 0;

    &::after {
      content: none;
    }

    &:hover::before {
      content: none;
    }
  }
}
</style>
